export function impermanentLoss(priceSwing: number) {
  return (Math.sqrt(priceSwing) / (priceSwing + 1)) * 2;
}

export function toAPR(n: number): number {
  const SECONDS_IN_YEAR = 365 * 24 * 3600;
  return n * SECONDS_IN_YEAR;
}

export function getWeightedAPR(
  leverage: number,
  weightA: number,
  aprA: number,
  weightB: number,
  aprB: number
) {
  const totalWeight = weightA + weightB;
  if (totalWeight === 0) return 0;
  const getWeightedSideAPR = (weight: number, apr: number) =>
    (weight / totalWeight) * (leverage - 1) * apr;
  return getWeightedSideAPR(weightA, aprA) + getWeightedSideAPR(weightB, aprB);
  /*
  let borrowMultiplierA = weightA / totalWeight * (data.currentLeverage - 1);
  let borrowMultiplierB = weightB / totalWeight * (data.currentLeverage - 1);
  if (borrowMultiplierA < 0) {
    borrowMultiplierB += borrowMultiplierA;
    borrowMultiplierA = 0;
  }
  if (borrowMultiplierB < 0) {
    borrowMultiplierA += borrowMultiplierB;
    borrowMultiplierB = 0;
  }
  const borrowAPR = borrowAPRA * borrowMultiplierA + borrowAPRB * borrowMultiplierB;*/
}

export function isValidNumber(n: number): boolean {
  return !(n === null || n === undefined || isNaN(n));
}
